
export const chooseYourVehicleScroll = {
    key: "choose-your-vehicle-scroll",
    init: (value) => {
        if(value && location.pathname.indexOf("/pages/choose-your-vehicle") == 0){
            console.log("Choose your vehicle scroll", value);
            var scrollArea = document.querySelector("image-link-blocks");
            if(scrollArea && window.innerWidth < 1000){
                scrollArea.style.setProperty('--image-link-blocks-grid', 'none');
            }
        }
    }
}